import { useContext } from "react";
import { UserContext } from "../contexts";
import { Typography } from "@mui/material";

export default function Main() {
  const { self } = useContext(UserContext);
  return <Typography>{JSON.stringify(self)}</Typography>;
}
